import * as React from "react";
import { useState } from "react";
import i18n from "i18n";
import {
  Grid,
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Link,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import bgCard from "common/assets/images/tutorial/bg.png";
import bancoComposicao from "common/assets/images/tutorial/bancoComposicao.png";
import criarQuantitativo from "common/assets/images/tutorial/criarQuantitativo.png";
import importarModelo from "common/assets/images/tutorial/importarModelo.png";
import importarPlanilha from "common/assets/images/tutorial/importarPlanilha.png";

const styles = (theme) => ({
  card: { backgroundColor: "#2E2E2E", width: "571px" },
  cardHeader: {
    backgroundColor: "#3A393E",
    fontSize: "24px",
    padding: "14px",
    textAlign: "center" as any,
    "& span": {
      color: "#9AAF00",
      fontWeight: "700" as any,
      lineHeight: "28px",
      fontFamily: "Roboto",
    },
  },
  cardActions: {
    backgroundColor: "#3A393E",
    justifyContent: "space-between",
    padding: "10px 12px 10px 24px",
    "& label": {
      "& span": {
        color: "#EEEEEE",
        fontSize: "12px",
        lineHeight: "14px",
        "& svg": { fontSize: "19px" },
      },
    },
  },
  btnNext: {
    backgroundColor: "#9AAF00",
    color: "#FFFFFF",
    padding: "8px 16px 8px 16px",
    fontSize: "14px",
    transition: ".3s",
    display: "flex",
    flexDirection: "row" as any,
    justifyContent: "center",
    alignItems: "flex-start",
    "&:hover": { backgroundColor: "#697513" },
  },
  ulStyle: {
    listStyle: "none",
    padding: "0px",
    margin: "0px",
    "& li": {
      padding: "8px",
      borderRadius: "4px",
      border: "1px solid #E5E5E5",
      backgroundColor: "rgba(0,0,0,.4)",
      color: "#EEEEEE",
      margin: "16px 0px",
      display: "flex",
      alignItems: "center",
      height: "48px",
      transition: ".2s",
      "&:nth-child(1)": {
        marginTop: "0px",
      },
      "& img": { marginRight: "24px" },
    },
  },
  liLink: {
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none!important",
      "& li": {
        backgroundColor: "rgba(0,0,0,.65)",
      },
    },
  },
  link: {
    color: "#1C9CEB",
    textAlign: "center" as any,
    textDecoration: "underline" as any,
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 400,
  },
  checkbox: {
    color: "#EEEEEE",
    "&$checked": {
      color: "#EEEEEE",
    },
  },
});

const WhatToLearn = (props) => {
  const { classes, changeTutorial } = props;
  const [showTutotial, setShowTutotial] = useState(true);

  return (
    <Card className={classes.card}>
      <CardHeader
        title={i18n.trialRegister.whatToLearn.whatLearn}
        className={classes.cardHeader}
      />
      <CardContent
        style={{
          padding: "24px 38px",
          backgroundImage: `url(${bgCard})`,
          backgroundPositionX: "-7px",
          height: "312px",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Grid container direction="column">
          <ul className={classes.ulStyle}>
            <Link
              className={classes.liLink}
              target="_blank"
              href="https://megasistemas.atlassian.net/wiki/spaces/helprubk/pages/510165127/Como+importar+uma+planilha+externa+para+o+Plano+de+Custo"
            >
              <li>
                <img src={importarPlanilha} alt="" />
                1. {i18n.trialRegister.whatToLearn.linkText01}
              </li>
            </Link>
            <Link
              className={classes.liLink}
              target="_blank"
              href="https://megasistemas.atlassian.net/wiki/spaces/helprubk/pages/510034149/Enviando+Modelos+BIM+3D+para+Biblioteca"
            >
              <li>
                <img src={importarModelo} alt="" /> 2.{" "}
                {i18n.trialRegister.whatToLearn.linkText02}
              </li>
            </Link>
            <Link
              className={classes.liLink}
              target="_blank"
              href="https://megasistemas.atlassian.net/wiki/spaces/helprubk/pages/510459957/Criando+Regras+de+Quantitativos"
            >
              <li>
                <img src={criarQuantitativo} alt="" /> 3.{" "}
                {i18n.trialRegister.whatToLearn.linkText03}
              </li>
            </Link>
            <Link
              className={classes.liLink}
              target="_blank"
              href="https://megasistemas.atlassian.net/wiki/spaces/helprubk/pages/510394837/Bancos+de+Composi+o"
            >
              <li>
                <img src={bancoComposicao} alt="" /> 4.{" "}
                {i18n.trialRegister.whatToLearn.linkText04}
              </li>
            </Link>
          </ul>
          <Link
            href="https://megasistemas.atlassian.net/wiki/spaces/helprubk/overview?homepageId=505610372"
            target="_blank"
            className={classes.link}
          >
            {i18n.trialRegister.whatToLearn.linkText05}
          </Link>
        </Grid>
      </CardContent>
      <CardActions className={classes.cardActions}>
        <FormControlLabel
          control={
            <Checkbox
              checked={!showTutotial}
              onChange={() => setShowTutotial(!showTutotial)}
              value="checkedG"
              classes={{
                root: classes.root,
                checked: classes.checked,
              }}
            />
          }
          label={i18n.trialRegister.whatToLearn.notDisplayMessage}
        />
        <Button
          size="small"
          className={classes.btnNext}
          onClick={() => changeTutorial(showTutotial)}
        >
          {i18n.begin}
        </Button>
      </CardActions>
    </Card>
  );
};

export default withStyles(styles)(WhatToLearn);



// WEBPACK FOOTER //
// ./src/modules/development/components/layouts/WhatToLearn.tsx